import { translateUi } from "@/shared/lib/ui-translate";
/**
 * Процесс получения списка стримов Twitch
 */

import { TwitchAPI, TwitchStream } from "../../api/twitch-api";

export interface StreamData {
  id: string;
  title: string;
  streamer: string;
  streamerAvatar: string;
  thumbnail: string;
  url: string;
  viewers: number;
  duration: string;
  startTime: string;
  platform: "twitch" | "youtube" | "vimeo";
  isLive: boolean;
}

export interface FetchStreamsParams {
  gameId?: string;
  limit?: number;
}

export interface FetchStreamsResult {
  success: boolean;
  streams?: StreamData[];
  error?: string;
}

// Функция конвертации TwitchStream в StreamData
function convertTwitchStreamToStreamData(
  twitchStream: TwitchStream,
): StreamData {
  return {
    id: twitchStream.id,
    title: twitchStream.title,
    streamer: twitchStream.user_name,
    streamerAvatar: `https://static-cdn.jtvnw.net/jtv_user_pictures/${twitchStream.user_id}-profile_image-70x70.png`,
    thumbnail: twitchStream.thumbnail_url,
    url: `https://www.twitch.tv/${twitchStream.user_login}`,
    viewers: twitchStream.viewer_count,
    duration: "LIVE",
    startTime: twitchStream.started_at,
    platform: "twitch",
    isLive: twitchStream.type === "live",
  };
}

export async function fetchTwitchStreams({
  gameId,
  limit = 20,
}: FetchStreamsParams): Promise<FetchStreamsResult> {
  try {
    // Валидация параметров
    if (limit && (limit < 1 || limit > 100)) {
      return {
        success: false,
        error: translateUi("litFetchStreams.limitOt1Do100"),
      };
    }

    // Получаем данные от Twitch API
    const twitchStreams = await TwitchAPI.getLiveStreams(gameId, limit);

    // Конвертируем в наш формат
    const streams = twitchStreams.map(convertTwitchStreamToStreamData);

    return {
      success: true,
      streams,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : translateUi("litFetchStreams.oshibkaPolucheniyaStrimov"),
    };
  }
}
